// https://spoonacular.com/food-api
// const checkApi = `https://api.spoonacular.com/recipes/633754/information?apiKey=4c417e01ad3344be8aa24da0ea396019&includeNutrition=true`;

import url from "../img/placeholder.jpg";

export const IMG_PLACEHOLDER = url;
export const API_URL = "https://api.spoonacular.com/";
export const API_KEY = "4c417e01ad3344be8aa24da0ea396019";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 6;
export const DATA_AOS = {
  animation: "fade-in",
  duration: 300,
  easing: "ease-in-out",
  once: true,
};
